import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addDeductionApprovalDetails = async (data) => {
  try {
    console.log(`deduction approval`, data);
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const updateDeductionApprovalDetails = async (data) => {
  try {
    console.log(`deduction approval`, data);
    return await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const searchDeductApproval = async (data) => {
  try {
    console.log(`item serch req`, data);
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval/search`,
      data,
    );
    console.log(`item serch res`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deductionApprovalById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval/searchByApprovalId?appId=${id}`,
    );
    console.log(`deductionItemById`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const checkApprovalTypeExistsByAppType = async (appType) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval/checkAppType?appType=${appType}`,
    );
    console.log(`checkApprovalTypeExists`, response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const approvalUserFindByUserId = async (user, appId, company) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/deductionApproval/user-id/${user}/${appId}/${company}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
